export default "__VITE_ASSET__c4e9bd76__"